import SpriteSymbol from "../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "SolidDataLowCoverage",
  "use": "SolidDataLowCoverage-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"SolidDataLowCoverage\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm0 11.5c1.178 0 2.22-.582 2.855-1.475l-2.44-1.731a1 1 0 0 1-.422-.802l-.04-2.992a3.5 3.5 0 0 0 .047 7Zm0 1.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol